import React, { useEffect, useState } from "react";

const OfferCountdown = () => {
  // Random duration between 1 and 24 hours (in seconds)
  const [timeLeft, setTimeLeft] = useState(() => {
    const randomHours = Math.floor(Math.random() * 24) + 1;
    return randomHours * 60 * 60;
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs}h ${mins}m ${secs}s`;
  };

  return (
    <div
      style={{
        backgroundColor: "#ff4d4dce",
        color: "white",
        padding: "10px 20px",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "18px",
        borderRadius: "8px",
        marginBottom: "20px",
        marginLeft:"5px",
        marginRight:"5px",
        filter: "drop-shadow(0 0 5px rgba(0,0,0,0.3))", 
      }}
    >
      🎉 Hurry! Offer ends in {formatTime(timeLeft)}
    </div>
  );
};

export default OfferCountdown;
